import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import './kloudless.css';
import KloudlessSwitch from './KloudlessSwitch';
import { connections } from '../redux/actions/kloudlessActions';
import box from './icons/box.png';
import dropbox from './icons/dropbox.png';
import gdrive from './icons/gdrive.png';
// skydrive suffered a rebranding on Microsoft end (now it's OneDrive),
// but Kloudless (Authenticator included) still calls it skydrive
import skydrive from './icons/onedrive.png';
import onedrivebiz from './icons/onedrivebiz.png';
import sharepointonline from './icons/sharepointonline.png';

const icons = {
  box,
  dropbox,
  gdrive,
  skydrive,
  onedrivebiz,
  sharepointonline,
};

class KloudlessLayout extends Component {
  componentDidMount = () => {
    this.props.dispatch(connections());
  }

  render() {
    const svcObj = this.props.svc.map((svcName, index) => {
      const connectionDetails = _.find(this.props.kloudless.results, { service: svcName }) || {};
      const key = `${svcName}-${index}`;

      const pps = {
        dispatch: this.props.dispatch,
        id: `${svcName}-control-${index}`,
        imgSrc: icons[svcName],
        connectionId: connectionDetails.connectionId || null,
        svcName,
      };

      return (
        <KloudlessSwitch key={key} {...pps} />
      );
    });

    if (this.props.kloudless.errorMessage) {
      return (
        <div className="error-loading">
          <p>this.props.kloudless.errorMessage</p>
        </div>
      );
    }

    if (this.props.kloudless.isLoading) {
      return (
        <div className="loading-data"><h2>Data is loading...</h2></div>
      );
    }

    return (
      <div >
        {svcObj}
      </div>
    );
  }
}

KloudlessLayout.propTypes = {
  dispatch: PropTypes.func.isRequired,
  kloudless: PropTypes.object.isRequired,
  svc: PropTypes.array.isRequired,
};


function mapStateToProps(state) {
  return {
    kloudless: state.get('kloudless'),
  };
}

export default connect(mapStateToProps)(KloudlessLayout);



/** WEBPACK FOOTER **
 ** ./src/kloudless/KloudlessLayout.jsx
 **/